var map = {
	"./de.po.json": 4200,
	"./es.po.json": 3954,
	"./id.po.json": 2414,
	"./pt.po.json": 6024,
	"./ru.po.json": 2904,
	"./tr.po.json": 9724,
	"./uk.po.json": 1744
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8556;